<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <div class="d-flex align-center mb-4">
      <DatePicker v-model="selectedDate" />
    </div>
    <v-data-table-server
      :headers="headers"
      :items-per-page="perPage"
      :items="cobros"
      :page="page"
      :items-length="totalCobros"
      :loading="loading"
      :item-value="id"
      @update:options="updateOptions"
      @update:items-per-page="onItemsPerPageChange"
      class="elevation-1"
      show-expand
      expand-on-click="false"
      :expanded="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!-- <v-text-field
            v-model="cobrosStore.search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="loadCobros"
          ></v-text-field> -->
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="newItem()"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.tipo`]="{ item }">
        {{ getTipoText(item.tipo) }}
      </template>
      <template v-slot:[`item.caja_fecha`]="{ item }">
        {{ formatDate(item.caja_fecha) }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        {{ formatCurrency(item.importe) }} €
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" color="green">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)" color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:expanded-row="{ item }">
        <tr
          v-if="item.detalle && item.detalle.trim() !== ''"
          class="expanded-detalle"
        >
          <td :colspan="headers.length">
            <div class="pa-4">{{ item.detalle }}</div>
          </td>
        </tr>
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue'
import { useCobrosStore } from '@/stores/cobrosStore'
import { useCajaStore } from '@/stores/cajaStore'
import { formatCurrency, formatDate, userIsRecepcion } from '@/utils/helpers'
import NoPermission from '@/components/common/NoPermission.vue'
import DatePicker from '@/components/common/DatePicker.vue'
import { storeToRefs } from 'pinia'
import { SELECT_COBROS } from '@/utils/constants'

const cobrosStore = useCobrosStore()
const { cobros, totalCobros, page, perPage } = storeToRefs(cobrosStore)
const loading = ref(false)
const cajaStore = useCajaStore()
const selectedDate = ref(null)
const expanded = ref([])

const emit = defineEmits(['edit', 'delete', 'newItem'])

const headers = ref([
  { title: 'Fecha', value: 'caja_fecha', align: 'center' },
  { title: 'Turno', key: 'turno', align: 'center' },
  { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
  { title: 'Registro', key: 'registro', align: 'center' },
  { title: 'Nº reserva', key: 'factura', align: 'center' },
  { title: 'Importe', key: 'importe', align: 'end' },
  // { title: 'Tipo', key: 'tipo', align: 'center' },
  { title: '', key: 'data-table-expand' },
  {
    title: '  ',
    width: '100px',
    key: 'actions',
    sortable: false
  }
])

onMounted(async () => {
  // Inicializar la fecha seleccionada con la fecha de la caja en formato ANSI
  await cajaStore.getLastCaja()

  const fecha = cajaStore.lastCaja?.fecha || new Date()
  if (fecha instanceof Date) {
    const year = fecha.getFullYear()
    const month = String(fecha.getMonth() + 1).padStart(2, '0')
    const day = String(fecha.getDate()).padStart(2, '0')
    selectedDate.value = `${year}-${month}-${day}`
  } else {
    selectedDate.value = fecha
  }

  // await loadCobros()
})

// Observar cambios en la fecha seleccionada
watch(selectedDate, () => {
  loadCobros()
})

const loadCobros = async () => {
  let fecha = selectedDate.value || null
  await cobrosStore.fetchCobros({ fecha: fecha })
}

const onItemsPerPageChange = (newItemsPerPage) => {
  perPage.value = newItemsPerPage
  cobrosStore.setRows(newItemsPerPage)
  loadCobros()
}

const deleteItem = (item) => {
  emit('delete', item.id)
}

const editItem = (item) => {
  console.log('EDITAR', item)
  emit('editItem', item)
}

const newItem = () => {
  emit('newItem')
}

const getTipoText = (tipo) => {
  const tipoObj = SELECT_COBROS.find((t) => t.value === tipo)
  return tipoObj ? tipoObj.text : tipo
}
</script>
